import { OrderFulfillment as OrderFulfillmentType } from '@open-tender/types'

const OrderFulfillment = ({
  arrival_info,
  has_arrived,
  vehicle_color,
  vehicle_id,
  vehicle_type,
}: OrderFulfillmentType) => {
  return (
    <>
      <p>
        {vehicle_color} {vehicle_type}
      </p>
      {vehicle_id ? <p>With license plate {vehicle_id}</p> : null}
      {has_arrived && (
        <p>Has arrived{arrival_info ? ` in spot ${arrival_info}` : null}</p>
      )}
    </>
  )
}

export default OrderFulfillment
